/**
 * If given a number say 10000 it converts it into 1K
 */
export const abbreviateNumber = (value: number) =>
  Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value)

/** Truncate toward zero to one decimal (e.g. 10.55 → "10.5"). */
function truncateOneDecimal(n: number): string {
  const t = Math.trunc(n * 10) / 10
  return t % 1 === 0 ? String(t) : t.toFixed(1)
}

/** Compact positive/negative number: ≥1M as Xm, ≥10k as Xk, else plain. */
export function formatCompactNumberLower(n: number): string {
  const sign = n < 0 ? '-' : ''
  const x = Math.abs(n)
  if (x >= 1_000_000) {
    const m = x / 1_000_000
    return `${sign}${truncateOneDecimal(m)}M`
  }
  if (x >= 10_000) {
    const k = x / 1_000
    return `${sign}${truncateOneDecimal(k)}K`
  }
  if (Number.isInteger(x)) return `${sign}${x}`
  return `${sign}${x}`
}

/**
 * Partner IQ company stat display: parses numeric strings (commas ok), returns
 * lowercase k/m for values ≥10k / ≥1M; non-numeric strings pass through.
 */
export function formatPartnerIqStatValue(raw: string): string {
  const trimmed = raw.trim()
  if (trimmed === '') return '00'
  const normalized = trimmed.replace(/,/g, '').replace(/^\$\s*/, '')
  const num = Number(normalized)
  if (!Number.isFinite(num)) return trimmed
  if (num === 0) return '00'
  return formatCompactNumberLower(num)
}

export const getFormattedValue = (number: number) => {
  return number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
